import { Grid, Typography } from "@mui/material";
import { dark_blue } from "./../../theme";

export function TermsConditionText() {
  const titleStyle = {
    fontSize: 20,
    fontWeight: "bold",
    textDecoration: "underline",
    marginBottom: 2,
    textAlign:'justify'
  };
  const subStyle = {
    fontSize: 20,
    fontWeight: "bold",
    marginBottom: 2,
    marginLeft: 6,
    textAlign:'justify'
  };
  const paragStyle = {
    fontSize: 20,
    marginBottom: 2,
    textAlign:'justify'

  

  };
  const subPparagStyle = {
    fontSize: 20,
    marginBottom: 2,
    marginLeft: 6,
    textAlign:'justify'
  };
  const listItemStyle = {
    fontSize: 20,
    fontFamily: "Lora, serif",
    color: dark_blue,
    marginBottom: 8,
 
  };

  return (
    <Grid sx={{}} container  spacing={3} justifyContent='center'  >
      <Grid item  lg={10} sm={6}  >
        <Typography sx={titleStyle} color={dark_blue} >
          1. Introduction and Overview.
        </Typography>
        <Typography sx={paragStyle}  color={dark_blue}>
          These Terms of Use (<b>“Terms”</b>) set forth a legally binding agreement between you and the Conference on Jewish
          Material Claims Against Germany (the <b>“Claims Conference”, “we”, “our”</b>, or<b> “us”</b>), and govern your use of
          any online service location that posts a link to these Terms, and all features, content, and other services that we own,
          control and make available through such online service location (collectively, the “Service”).{" "}
        </Typography>
        <Typography sx={paragStyle} color={dark_blue} textAlign='justify'>
          <b>
            PLEASE NOTE THAT THESE TERMS CONTAIN PROVISIONS THAT GOVERN THE RESOLUTION OF DISPUTES BETWEEN US AND YOU AND LIMIT
            OUR LIABILITY TO YOU (SEE AGREEMENT TO ARBITRATE DISPUTES BELOW). THESE PROVISIONS SIGNIFICANTLY AFFECT YOUR LEGAL
            RIGHTS, INCLUDING YOUR RIGHT TO FILE A LAWSUIT IN COURT AND TO HAVE A JURY HEAR YOUR CLAIMS. IT CONTAINS PROCEDURES
            FOR BINDING ARBITRATION AND A CLASS ACTION WAIVER{" "}
          </b>
        </Typography>
        <Typography sx={paragStyle} color={dark_blue} textAlign='justify'>
          In some instances, both these Terms and separate terms elsewhere on the Service will apply to your use of the Service (
          <b>“Additional Terms”</b>). To the extent there is a conflict between these Terms and any applicable Additional Terms,
          the Additional Terms will control unless they expressly state otherwise.
        </Typography>
        <Typography sx={paragStyle} color={dark_blue} textAlign='justify'>
          By using the Service, you agree to these Terms. If you do not agree and consent, discontinue use of the Service.{" "}
        </Typography>
        <Typography sx={titleStyle} color={dark_blue}>
          2. Service Use.
        </Typography>
        <Typography sx={subStyle} color={dark_blue}>
          A. Content.
        </Typography>
        <Typography sx={paragStyle} color={dark_blue} textAlign='justify'>
          The Service contains: (i) materials and other items relating to the Claims Conference and its services, and similar
          items from our licensors and other third parties, including all layout, information, databases, articles, posts, text,
          data, files, images, scripts, designs, graphics, instructions, illustrations, photographs, sounds, pictures, videos,
          advertising copy, URLs, technology, software, interactive features, the “look and feel” of the Service, and the
          compilation, assembly, and arrangement of the materials of the Service and any and all copyrightable material; (ii)
          trademarks, logos, trade names, trade dress, service marks, and trade identities of various parties, including those of
          the Claims Conference; and (iii) other forms of intellectual property (all of the foregoing, collectively{" "}
          <b>“Content”</b>). All right, title, and interest in and to the Service and the Content is the property of the Claims
          Conference or our licensors or certain other third parties, and is protected by U.S. and international copyright,
          trademark, trade dress, patent and/or other intellectual property and unfair competition rights and laws to the fullest
          extent possible.{" "}
        </Typography>
        <Typography sx={subStyle} color={dark_blue}>
          B. Limited License.
        </Typography>
        <Typography sx={paragStyle} color={dark_blue} textAlign='justify'>
          Subject to your strict compliance with these Terms and any applicable Additional Terms, the Claims Conference grants you
          a limited, non-exclusive, revocable, non-assignable, personal, and nontransferable license to download, display, view,
          use, and play the Content on a personal computer, browser, laptop, tablet, mobile phone, or other internet-enabled
          device (each, a <b>“Device”</b>) and/or print one copy of the Content as it is displayed to you, in each case for your
          personal, non-commercial use only. The foregoing limited license (i) does not give you any ownership of, or any other
          intellectual property interest in, any Content, and (ii) may be suspended or terminated for any reason, in the Claims
          Conference’s sole discretion, and without advance notice or liability. Your unauthorized use of the Content may violate
          copyright, trademark, privacy, publicity, communications, and other laws, and any such use may result in your personal
          liability, including potential criminal liability.
        </Typography>
        <Typography sx={subStyle} color={dark_blue}>
          C. Accounts.
        </Typography>
        <Typography sx={paragStyle} color={dark_blue} textAlign='justify'>
          Use of the Service may require you to register an account. When registering an account, you agree to: (i) provide true,
          accurate, current, and complete information; (ii) maintain and update this information to keep it true, accurate,
          current, and complete; (iii) protect and prevent unauthorized access to your account; (iv) not transfer or share your
          account with any third party; and (v) immediately notify us of any suspected or actual unauthorized use of your account
          or breach of security. Please note that you are solely responsible for all activities that occur under your account,
          whether or not you authorized the activity, and we are not liable for any loss or damage to you or any third party
          arising from your failure to comply with any of the foregoing obligations.{" "}
        </Typography>
        <Typography sx={subStyle} color={dark_blue}>
          D. Restrictions.
        </Typography>
        <Typography sx={paragStyle} color={dark_blue} textAlign='justify'>
          You may not use the Service unless you are at least eighteen (18) years old.
        </Typography>
        <Typography sx={paragStyle} color={dark_blue} textAlign='justify'>
          You may not: (i) use the Service or Content for any political or commercial purpose; (ii) engage in any activity in
          connection with the Service or Content that is unlawful, harmful, falsely representative of your persona, invasive of
          someone else’s privacy, or otherwise objectionable to the Claims Conference; (iii) harvest any information from the
          Service or Content; (iv) reverse engineer or modify the Service or Content; (v) interfere with the proper operation of
          or any security measure used by the Service or Content; (vi) infringe any intellectual property or other right of any
          third party; (vii) use the Service or Content in a manner that suggests an unauthorized association or is beyond the
          scope of the limited license granted to you; or (viii) otherwise violate these Terms or any applicable Additional Terms.{" "}
        </Typography>
        <Typography sx={paragStyle} color={dark_blue}>
          You agree to comply with all local, state, federal, national, foreign, supranational, and international laws, statutes,
          ordinances, regulations, treaties, directives, and agreements that apply to your use of the Service and Content.{" "}
        </Typography>
        <Typography sx={subStyle} color={dark_blue}>
          E. Availability.
        </Typography>
        <Typography sx={paragStyle} color={dark_blue}>
          The Claims Conference may suspend or terminate the availability of the Service and Content, in whole or in part, to any
          individual user or all users, for any reason, in the Claims Conference’s sole discretion, and without advance notice or
          liability. Upon suspension or termination of your access to the Service, or upon notice from the Claims Conference, all
          rights granted to you under these Terms, or any applicable Additional Terms will cease immediately, and you agree that
          you will immediately discontinue use of the Service and Content.{" "}
        </Typography>
        <Typography sx={subStyle} color={dark_blue}>
          F. Reservation of Rights.
        </Typography>
        <Typography sx={paragStyle} color={dark_blue}>
          All rights not expressly granted to you are reserved by the Claims Conference and its licensors and other third parties.
          No right or license may be construed, under any legal theory, by implication, estoppel, industry custom, or otherwise.
          Any unauthorized use of the Content or Service for any purpose is prohibited.
        </Typography>
        <Typography sx={titleStyle} color={dark_blue}>
          3. Copyright Infringement.
        </Typography>
        <Typography sx={subStyle} color={dark_blue}>
          A. DMCA Notification.
        </Typography>
        <Typography sx={paragStyle} color={dark_blue}>
          The Claims Conference responds to copyright notifications submitted under the Digital Millennium Copyright Act, 17
          U.S.C. § 512 (<b>“DMCA”</b>). To submit a notice of claimed copyright infringement under U.S. law, provide our
          designated agent with the following written information:{" "}
        </Typography>
        <ul>
          <li style={listItemStyle}>
            A physical or electronic signature of the copyright owner or a person authorized to act on his or her behalf;{" "}
          </li>
          <li style={listItemStyle}>Identification of the copyrighted work claimed to have been infringed;</li>
          <li style={listItemStyle}>
            Identification of the infringing material and information reasonably sufficient to permit us to locate that material;{" "}
          </li>
          <li style={listItemStyle}>
            Your contact information, including your address, telephone number, and an email address;
          </li>
          <li style={listItemStyle}>
            A statement that you have a good faith belief that the use of the material in the manner asserted is not authorized by
            the copyright owner, its agent, or the law; and
          </li>
          <li style={listItemStyle}>
            A statement that the information in the notification is accurate, and, under penalty of perjury, that you are
            authorized to act on behalf of the copyright owner.
          </li>
        </ul>
        <Typography sx={paragStyle} color={dark_blue}>
          Our designated agent is:{" "}
        </Typography>
        <Typography sx={paragStyle} color={dark_blue}>
          Legal Department <br></br>
          P.O. Box 1215, New York NY 10113 <br></br>
          legal@claimscon.org <br></br>
        </Typography>
        <Typography sx={paragStyle} color={dark_blue}>
          You can obtain further information from the Copyright Office’s onlin e directory at
          <a href="https://dmca.copyright.gov/osp/"> www.dmca.copyright.gov/osp</a>.
        </Typography>
        <Typography sx={paragStyle} color={dark_blue}>
          We will respond to notifications of claimed copyright infringement in accordance with the DMCA.{" "}
        </Typography>
        <Typography sx={subStyle} color={dark_blue}>
          B. Counter Notification.{" "}
        </Typography>
        <Typography sx={paragStyle} color={dark_blue}>
          If you believe that your material has been removed in error in response to a copyright notification, you may submit a
          counter notification to our designated agent with the following written information:
        </Typography>
        <ul>
          <li style={listItemStyle}>A physical or electronic signature;</li>
          <li style={listItemStyle}>
            Identification of the material that has been removed or to which access has been disabled and the location at which
            the material appeared before it was removed or access to it was disabled;
          </li>
          <li style={listItemStyle}>
            IA statement under penalty of perjury that you have a good faith belief that the material was removed or disabled as a
            result of mistake or misidentification of the material to be removed or disabled; and
          </li>
          <li style={listItemStyle}>
            Your name, address, and telephone number, and a statement that you consent to the jurisdiction of the Federal District
            Court for the judicial district in which the address is located, or if your address is outside of the U.S., for any
            judicial district in which the Claims Conference may be found, and that you will accept service of process from the
            person who provided notification under subsection (c)(1)(C) or an agent of such person.
          </li>
        </ul>
        <Typography sx={paragStyle} color={dark_blue}>
          We will respond to counter notifications in accordance with the DMCA.
        </Typography>
        <Typography sx={titleStyle} color={dark_blue}>
          4. Third Party Services.{" "}
        </Typography>
        <Typography sx={paragStyle} color={dark_blue}>
          Our Service contains content from and hyperlinks to websites, locations, platforms, and services operated and owned by
          third parties (<b>“Third Party Services”</b>). We may also integrate third party technologies into our Service and host
          our content on Third Party Services. These Third Party Services are not owned, controlled, or operated by us, and you
          acknowledge and agree that we are not responsible or liable for the information, content, products, technologies, or
          services on or available from such Third Party Services, or for the results to be obtained from using them. If you
          choose to access, transact with, or otherwise interact with any such Third Party Services, you do so at your own risk.
          Our Service contains content from and hyperlinks to websites, locations, platforms, and services operated and owned by
          third parties (“Third Party Services”). We may also integrate third party technologies into our Service and host our
          content on Third Party Services. These Third Party Services are not owned, controlled, or operated by us, and you
          acknowledge and agree that we are not responsible or liable for the information, content, products, technologies, or
          services on or available from such Third Party Services, or for the results to be obtained from using them. If you
          choose to access, transact with, or otherwise interact with any such Third Party Services, you do so at your own risk.
          Our Service contains content from and hyperlinks to websites, locations, platforms, and services operated and owned by
          third parties (“Third Party Services”). We may also integrate third party technologies into our Service and host our
          content on Third Party Services. These Third Party Services are not owned, controlled, or operated by us, and you
          acknowledge and agree that we are not responsible or liable for the information, content, products, technologies, or
          services on or available from such Third Party Services, or for the results to be obtained from using them. If you
          choose to access, transact with, or otherwise interact with any such Third Party Services, you do so at your own risk.
        </Typography>
        <Typography sx={titleStyle} color={dark_blue}>
          5. Agreement to Arbitrate Disputes and Choice of Law.{" "}
        </Typography>
        <Typography sx={paragStyle} color={dark_blue}>
          <b>
            PLEASE READ THIS SECTION CAREFULLY – IT MAY SIGNIFICANTLY AFFECT YOUR LEGAL RIGHTS, INCLUDING YOUR RIGHT TO FILE A
            LAWSUIT IN COURT AND TO HAVE A JURY HEAR YOUR CLAIMS. IT CONTAINS PROCEDURES FOR BINDING ARBITRATION AND A CLASS
            ACTION WAIVER.
          </b>
        </Typography>
        <Typography sx={subStyle} color={dark_blue}>
          A. We Both Agree to Arbitrate.
        </Typography>
        <Typography sx={paragStyle} color={dark_blue}>
          You and the Claims Conference agree to resolve any claims relating to these Terms through final and binding arbitration,
          except to the extent you have in any manner violated or threatened to violate the Claims Conference’s intellectual
          property rights (for example, trademark, trade secret, copyright, or patent rights). Under such circumstances the Claims
          Conference may bring a lawsuit solely for injunctive relief to stop unauthorized use or abuse of the Service, or
          intellectual property infringement (for example, trademark, trade secret, copyright, or patent rights) without first
          engaging in arbitration or the informal dispute-resolution process described herein.
        </Typography>
        <Typography sx={subStyle} color={dark_blue}>
          B. What is Arbitration.
        </Typography>
        <Typography sx={paragStyle} color={dark_blue}>
          Arbitration is more informal than a lawsuit in court and seeks to resolve disputes more quickly. Instead of a judge or a
          jury, the case will be decided by a neutral arbitrator who has the power to award the same damages and relief that a
          court can. If any provision of this arbitration agreement is found unenforceable, the unenforceable provision shall be
          severed, and the remaining arbitration terms shall be enforced.{" "}
        </Typography>
        <Typography sx={subStyle} color={dark_blue}>
          C. Arbitration Procedures.
        </Typography>
        <Typography sx={paragStyle} color={dark_blue}>
          The Federal Arbitration Act governs the interpretation and enforcement of this dispute resolution provision. Arbitration
          shall be initiated through JAMS. Any dispute, controversy, or claim arising out of or relating to these Terms shall be
          referred to and finally determined by arbitration in accordance with the JAMS Streamlined Arbitration Rules and
          Procedures in front of one arbitrator. If there is a conflict between JAMS Rules and the rules set forth in these Terms,
          the rules set forth in this Terms will govern. The JAMS Rules and instructions for how to initiate an arbitration are
          available from JAMS at <a href="http://www.jamsadr.com"> http://www.jamsadr.com</a> or 1-800-352-5267. To initiate
          arbitration, you or the Claims Conference must do the following things:
        </Typography>
        <Typography sx={subPparagStyle} color={dark_blue}>
          (1) Write a demand for Arbitration. The demand must include a description of the Claim and the amount of damages sought
          to be recovered. You can find a copy of a demand for Arbitration at www.jamsadr.com.
        </Typography>
        <Typography sx={subPparagStyle} color={dark_blue}>
          (2) Send three copies of the demand for Arbitration, plus the appropriate filing fee to: JAMS to your local JAMS office
          or to JAMS, Two Embarcadero Center, Suite 1500, San Francisco, CA 94111.
        </Typography>
        <Typography sx={subPparagStyle} color={dark_blue}>
          (3) Send one copy of the demand for Arbitration to the other party.
        </Typography>
        <Typography sx={paragStyle} color={dark_blue}>
          Payment of all filing, administration and arbitrator fees will be governed by the JAMS Rules. The arbitration hearing
          may be by telephone or in-person. Disputes may also be resolved by submission of documents and without in-person or
          telephonic hearings as provided by the Rules. To the extent necessary, the locale of the hearing will be the county of
          the consumer’s home address or, at the consumer’s election, such other locale as mutually agreed to by the parties, or
          as determined by the arbitrator. Each party will bear their own costs of arbitration unless the arbitrator directs that
          bearing such costs would be an undue burden and in that case, we will pay for your portion of the arbitration
          administrative costs (but not your attorneys’ fees). Arbitration under this agreement shall be held under New York law
          without regard to its conflict of laws provisions. The arbitration may award on an individual basis the same damages and
          relief as a court (including injunctive relief). Any judgment on the award rendered by the arbitrator may be entered in
          any court of competent jurisdiction.
        </Typography>
        <Typography sx={subStyle} color={dark_blue}>
          D. Authority of Arbitrator.{" "}
        </Typography>
        <Typography sx={paragStyle} color={dark_blue}>
          The arbitrator will decide the rights and liabilities, if any, of you and the Claims Conference, and the dispute will
          not be consolidated with any other matters or joined with any other cases or parties. The arbitrator shall have the
          authority to grant motions dispositive of all or part of any claim. The arbitrator shall have the authority to award
          monetary damages and to grant any non-monetary remedy or relief available to an individual under applicable law, the
          Arbitration Rules, and the Terms. The arbitrator shall issue a written award and statement of decision describing the
          essential findings and conclusions on which the award is based, including the calculation of any damages awarded. The
          arbitrator has the same authority to award relief on an individual basis that a judge in a court of law would have. The
          award of the arbitrator is final and binding upon you and the Claims Conference{" "}
        </Typography>
        <Typography sx={subStyle} color={dark_blue}>
          E. No Class Actions.
        </Typography>
        <Typography sx={paragStyle} color={dark_blue}>
          You may only resolve disputes with us on an individual basis, and may not bring a claim as a plaintiff or a class member
          in a class, consolidated, or representative action. Class arbitrations, class actions, private attorney general actions,
          and consolidation with other arbitrations are not allowed.
        </Typography>
        <Typography sx={subStyle} color={dark_blue}>
          F. Exceptions to Arbitration.
        </Typography>
        <Typography sx={paragStyle} color={dark_blue}>
          This Agreement to Arbitrate shall not require arbitration of the following types of disputes: (1) small claims actions
          brought on an individual basis that are within the scope of such small claims court’s jurisdiction; or (2) a
          representative action brought on behalf of others under PAGA or other private attorneys general acts, to the extent the
          Representative PAGA Waiver of such action is deemed unenforceable by a court of competent jurisdiction under applicable
          law not preempted by the FAA.{" "}
        </Typography>
        <Typography sx={subStyle} color={dark_blue}>
          G. Waiver of Jury Trial.
        </Typography>
        <Typography sx={paragStyle} color={dark_blue}>
          THE PARTIES HEREBY WAIVE THEIR CONSTITUTIONAL AND STATUTORY RIGHTS TO GO TO COURT AND HAVE A TRIAL IN FRONT OF A JUDGE
          OR A JURY, instead electing that all claims and disputes shall be resolved by arbitration. Arbitration procedures are
          typically more limited, more efficient and less costly than rules applicable in court and are subject to very limited
          review by a court. In the event any litigation should arise between you and the Claims Conference in any state or
          federal court in a suit to vacate or enforce an arbitration award or otherwise, YOU AND THE CLAIMS CONFERENCE WAIVE ALL
          RIGHTS TO A JURY TRIAL, instead electing that the dispute be resolved by a judge. YOU ACKNOWLEDGE THAT YOU HAVE BEEN
          ADVISED THAT YOU MAY CONSULT WITH AN ATTORNEY IN DECIDING TO ACCEPT THIS AGREEMENT TO ARBITRATE.{" "}
        </Typography>
        <Typography sx={subStyle} color={dark_blue}>
          H. Choice of Law/Forum Selection.
        </Typography>
        <Typography sx={paragStyle} color={dark_blue}>
          In any circumstances where the Agreement to Arbitrate Disputes permits the parties to litigate in court, these Terms
          shall be governed by and construed in accordance with the laws of the State of New York, excluding its conflict of law
          rules. You further expressly consent and agree to submit to the exclusive jurisdiction and venue of a court of competent
          jurisdiction located in New York, NY.{" "}
        </Typography>
        <Typography sx={subStyle} color={dark_blue}>
          I. Opt-Out of Agreement to Arbitrate.
        </Typography>
        <Typography sx={paragStyle} color={dark_blue}>
          You can decline this Agreement to Arbitrate by emailing the Claims Conference at [EMAIL] and providing the requested
          information as follows: (1) Your Name; (2) the URL of the Terms and Agreement to Arbitrate Disputes; (3) Your Address;
          (4) Your Phone Number; (5) and clear statement that you wish to opt out of this arbitration provision in the Terms. The
          Opt-Out Notice must be emailed no later than 30 days after the date you first accept the Terms by using the Service.{" "}
        </Typography>
        <Typography sx={titleStyle} color={dark_blue}>
          6. Disclaimer of Representations and Warranties.{" "}
        </Typography>
        <Typography sx={paragStyle} color={dark_blue}>
          THE SERVICE IS PROVIDED TO YOU ON AN "AS IS," "AS AVAILABLE," AND "WITH ALL FAULTS" BASIS. NEITHER THE CLAIMS CONFERENCE
          NOR ANY OF ITS OFFICERS, DIRECTORS, MANAGERS, EMPLOYEES OR AGENTS (COLLECTIVELY, THE{" "}
          <b>"THE CLAIMS CONFERENCE PARTIES"</b>) MAKE ANY REPRESENTATIONS, WARRANTIES OR ENDORSEMENTS OF ANY KIND WHATSOEVER AS
          TO THE CONTENT OR OTHER SERVICES, WHETHER EXPRESS OR IMPLIED, STATUTORY OR OTHERWISE, OR ARISING FROM COURSE OF DEALING,
          COURSE OF PERFORMANCE OR USAGE OF TRADE, INCLUDING THE IMPLIED WARRANTIES OF TITLE, NON-INFRINGEMENT, MERCHANTABILITY,
          FITNESS FOR A PARTICULAR PURPOSE, QUIET ENJOYMENT AND FREEDOM FROM COMPUTER VIRUS. BY ACCESSING OR USING THE SERVICE YOU
          REPRESENT AND WARRANT THAT YOUR ACTIVITIES ARE LAWFUL IN EVERY JURISDICTION WHERE YOU ACCESS OR USE THE SERVICE.
        </Typography>
        <Typography sx={paragStyle} color={dark_blue}>
          NOTWITHSTANDING THE FOREGOING, THESE DISCLAIMERS DO NOT EXCLUDE ANY PRODUCT LIABILITY CLAIMS, STATUTORY CONSUMER RIGHTS,
          DAMAGES ASSOCIATED WITH PERSONAL INJURY OR RESULTING FROM THE CLAIMS CONFERENCE INTENTIONAL MISCONDUCT, RECKLESSNESS,
          FRAUD, OR GROSS NEGLIGENCE.
        </Typography>
        <Typography sx={titleStyle} color={dark_blue}>
          7. Limitations of Our Liability.
        </Typography>
        <Typography sx={paragStyle} color={dark_blue}>
          TO THE MAXIMUM EXTENT PERMITTED BY LAW, IN NO EVENT SHALL THE CLAIMS CONFERENCE PARTIES BE LIABLE TO YOU FOR ANY LOSS,
          DAMAGE OR INJURY OF ANY KIND INCLUDING ANY DIRECT, INDIRECT, SPECIAL, INCIDENTAL, EXEMPLARY, CONSEQUENTIAL OR PUNITIVE
          LOSSES OR DAMAGES, OR DAMAGES FOR SYSTEM FAILURE OR MALFUNCTION OR LOSS OF PROFITS, DATA, USE, BUSINESS OR GOODWILL,
          ARISING OUT OF OR IN CONNECTION WITH (A) THE SERVICE, (B) THESE TERMS OR (C) YOUR MISUSE OF THE SERVICE OR ANY CONTENT
          AVAILABLE ON OR THROUGH THE SERVICE. THE LIMITATIONS SET FORTH IN THIS SECTION SHALL APPLY REGARDLESS OF THE FORM OF
          ACTION, WHETHER THE ASSERTED LIABILITY OR DAMAGES ARE BASED ON CONTRACT, INDEMNIFICATION, TORT, STRICT LIABILITY,
          STATUTE OR ANY OTHER LEGAL OR EQUITABLE THEORY. IN NO EVENT SHALL THE TOTAL AGGREGATE LIABILITY OF THE CLAIMS CONFERENCE
          FOR ANY CLAIMS HEREUNDER EXCEED $100.
        </Typography>
        <Typography sx={paragStyle} color={dark_blue}>
          NOTWITHSTANDING THE FOREGOING, THESE DISCLAIMERS HEREIN DO NOT EXCLUDE ANY PRODUCT LIABILITY CLAIMS, STATUTORY CONSUMER
          RIGHTS, DAMAGES ASSOCIATED WITH PERSONAL INJURY OR RESULTING FROM THE CLAIMS CONFERENCE’S INTENTIONAL MISCONDUCT,
          RECKLESSNESS, FRAUD, OR GROSS NEGLIGENCE.{" "}
        </Typography>
        <Typography sx={titleStyle} color={dark_blue}>
          8. Indemnification.
        </Typography>
        <Typography sx={paragStyle} color={dark_blue}>
          You agree to defend, indemnify and hold harmless the Claims Conference Parties from and against any and all claims,
          liabilities, damages, losses, costs and expenses (including, reasonable attorneys’ fees and costs) arising out of or in
          connection with any of the following: (i) your breach or alleged breach of these Terms; (ii) your misuse of the Service;
          (iv) your violation of any laws, rules, regulations, codes, statutes, ordinances or orders of any governmental or
          quasi-governmental authorities; (v) your violation of the rights of any third party, including any intellectual property
          right, publicity, confidentiality, property or privacy right; (vi) your use of a Third Party Service; or (vii) any
          misrepresentation made by you. The Claims Conference reserves the right to assume, at your expense, the exclusive
          defense and control of any matter subject to indemnification by you. You agree to cooperate with the Claims Conference’s
          defense of any claim. You will not in any event settle any claim without the prior written consent of the Claims
          Conference.
        </Typography>
        <Typography sx={paragStyle} color={dark_blue}>
          This provision does not require you to indemnify us for any unconscionable commercial practice by us or for our fraud,
          deception, false promise, misrepresentation or concealment, suppression or omission of any material fact in connection
          with the Service.
        </Typography>
        <Typography sx={titleStyle} color={dark_blue}>
          9. Waiver of Injunctive or other Equitable Relief.
        </Typography>
        <Typography sx={paragStyle} color={dark_blue}>
          TO THE MAXIMUM EXTENT PERMITTED BY LAW, YOU AGREE THAT YOU WILL NOT BE PERMITTED TO OBTAIN AN INJUNCTION OR OTHER
          EQUITABLE RELIEF OF ANY KIND, SUCH AS ANY COURT OR OTHER ACTION THAT MAY INTERFERE WITH OR PREVENT THE DEVELOPMENT OR
          EXPLOITATION OF ANY WEBSITE, APPLICATION, CONTENT, SUBMISSIONS, PRODUCT, SERVICE, OR INTELLECTUAL PROPERTY OWNED,
          LICENSED, USED OR CONTROLLED BY THE CLAIMS CONFERENCE OR A LICENSOR OF THE CLAIMS CONFERENCE.
        </Typography>
        <Typography sx={titleStyle} color={dark_blue}>
          10. Updates to Terms.
        </Typography>
        <Typography sx={paragStyle} color={dark_blue}>
          We reserve the right, at any time in our sole discretion, to modify or replace any part of these Terms and any
          applicable Additional Terms, without prior notice. You agree that we may notify you of any updated Terms and any
          applicable Additional Terms by posting them on the Service so that they are accessible via a link from the home page,
          and/or to send you an email to the last email address you provided to us. All such changes are effective immediately
          when we post them, or such later date as may be specified in the notice of updated Terms and any applicable Additional
          Terms. If you object to any such changes, your sole recourse is to cease using the Service.
        </Typography>
        <Typography sx={titleStyle} color={dark_blue}>
          11. General Provisions.
        </Typography>
        <Typography sx={subStyle} color={dark_blue}>
          A. Consent or Approval.
        </Typography>
        <Typography sx={paragStyle} color={dark_blue}>
          The consent or approval of the Claims Conference may not be deemed to have been granted by the Claims Conference without
          being in writing and signed by an officer of the Claims Conference.{" "}
        </Typography>
        <Typography sx={subStyle} color={dark_blue}>
          B. Survival.
        </Typography>
        <Typography sx={paragStyle} color={dark_blue}>
          The provisions of these Terms and any applicable Additional Terms, which by their nature should survive termination of
          your use of the Service, including sections on Service Use (except for the limited license), Copyright Infringement,
          Third Party Services, Agreement to Arbitrate Disputes and Choice of Law, Disclaimer of Representations and Warranties,
          Limitations of Our Liability, Indemnification, Waiver of Injunctive or Other Equitable Relief, Updates to Terms, and
          General Provisions, will survive.
        </Typography>
        <Typography sx={subStyle} color={dark_blue}>
          C. Severability; Interpretation; Assignment.
        </Typography>
        <Typography sx={paragStyle} color={dark_blue}>
          If any provision of these Terms, or any applicable Additional Terms, is for any reason deemed invalid, unlawful, void,
          or unenforceable, then that provision will be deemed severable from these Terms or the Additional Terms, and the
          invalidity of the provision will not affect the validity or enforceability of the remainder of these Terms or the
          Additional Terms. You hereby waive any applicable statutory and common law that may permit a contract to be construed
          against its drafter. The summaries of provisions and section headings are provided for convenience only and shall not
          limit the full Terms. The Claims Conference may assign its rights and obligations under these Terms and any applicable
          Additional Terms, in whole or in part, to any party at any time without any notice. These Terms and any applicable
          Additional Terms may not be assigned by you, and you may not delegate your duties under them, without the prior written
          consent of an officer of the Claims Conference.
        </Typography>
        <Typography sx={subStyle} color={dark_blue}>
          D. Complete Agreement; No Waiver.{" "}
        </Typography>
        <Typography sx={paragStyle} color={dark_blue}>
          These Terms, and any applicable Additional Terms, reflect our complete agreement regarding the Service and supersede any
          prior agreements, representations, warranties, assurances or discussion related to the Service. Except as expressly set
          forth in these Terms or any applicable Additional Terms, (i) no failure or delay by you or the Claims Conference in
          exercising any of rights, powers, or remedies under will operate as a waiver of that or any other right, power, or
          remedy, and (ii) no waiver or modification of any term of these Terms or any applicable Additional Terms will be
          effective unless in writing and signed by the party against whom the waiver or modification is sought to be enforced.
        </Typography>
        <Typography sx={subStyle} color={dark_blue}>
          E. International Issues.
        </Typography>
        <Typography sx={paragStyle} color={dark_blue}>
          The Claims Conference reserves the right to investigate and prosecute any suspected breaches of these Terms or the
          Service. The Claims Conference may disclose any information as necessary to satisfy any law, regulation, legal process
          or governmental request.{" "}
        </Typography>
        <Typography sx={subStyle} color={dark_blue}>
          F. Investigations; Cooperation with Law Enforcement.
        </Typography>
        <Typography sx={paragStyle} color={dark_blue}>
          The Claims Conference controls and operates the Service from the U.S. Software related to or made available by the
          Service may be subject to export controls of the U.S., and, except as authorized by law, you agree and warrant not to
          export or re-export the software to any county, or to any person, entity, or end-user subject to U.S. export controls or
          sanctions.{" "}
        </Typography>
        <Typography sx={subStyle} color={dark_blue}>
          G. California Consumer Rights and Notices.
        </Typography>
        <Typography sx={paragStyle} color={dark_blue}>
          Residents of California are entitled to the following specific consumer rights information: you may contact the
          Complaint Assistance Unit of the Division of Consumer Services of the Department of Consumer Affairs by mail at: 400 R
          St., Suite 1080, Sacramento, California, 95814, or by telephone at (916) 445-1254. Their website is located at:
          <a href="http://www.dca.ca.gov"> http://www.dca.ca.gov.</a>
        </Typography>
        <Typography sx={titleStyle} color={dark_blue}>
          12. Contact Us.
        </Typography>
        <Typography sx={{ ...paragStyle, fontSize: 20 }} color={dark_blue}>
          If you have any questions or comments, please send an email to us at <b>info@claimscon.org.</b> All legal notices to us
          must be mailed to: Legal Department - The Claims Conference, P.O. Box 1215, New York N.Y. 10113. When you communicate
          with us electronically, you consent to receive communications from us electronically. You agree that all agreements,
          notices, disclosures, and other communications that we provide to you electronically satisfy any legal requirement that
          such communications be in writing.
        </Typography>
      </Grid>
    </Grid>
  );
}